import React, { FC } from 'react';

export const Loader: FC = () => (
  <div className="loader-wrapper">
    <span className="loader"></span>
  </div>
);
